import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getForReseller (resellerId) {
    return Api()
      .get('/v1/admin/customers/' + resellerId)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Customer.Messages.LoadingCustomersErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
